import historyManager from 'components/history-manager';
import { foreach, makeUrl } from 'components/utils';
import { activateFilterToggle, activateFilterTextfield } from 'components/search-page-functions';
import $ from 'jquery';
import 'components/fengyuanchen_datepicker';

let searchHandler = null;

/**
 * Initiates / starts the search: loads results based on the filters from the backend
 */
function initSearch(params, page = 0, allPages = false) {
    showLoader();
    if (searchHandler) {
        searchHandler.abort();
        searchHandler = null;
    }
    // clear result content on first page:
    if (page === 0) {
        resultContainer.html('');
    }
    let shadowParams = Object.assign({}, params);
    shadowParams.page = page;
    shadowParams.allPages = allPages;
    searchHandler = $.get(makeUrl('/schauplaetze/search'), shadowParams)
        .done((res) => {
            resultContainer.append(res);
        })
        .always(() => {
            searchHandler = null;
            hideLoader();
        });
}

/**
 * shows a loading indicator. resultcontainer must be a jquery object.
 */
function showLoader(resultcontainer) {
    loaderContainer.html('<div class="searching"></div>');
}

/**
 * hides a loading indicator. resultcontainer must be a jquery object.
 */
function hideLoader(resultcontainer) {
    loaderContainer.html('');
}

const resultContainer = $('#searchresult-container');
const loaderContainer = $('#loader-container');

// Init all filter elements that listen for user click / history changes:
let filterLinks = document.querySelectorAll('a[data-filter],li[data-filter],input[data-filter][type=checkbox]');
let filterTextfields = document.querySelectorAll('input[data-filter][type=search]');

$('[data-filter=publishedSince]').on('click', (e) => {
    $('#publishedDateFrom').val(null);
    $('#publishedDateTo').val(null);
    historyManager.removeParamFromCache('publishedDateFrom');
    historyManager.removeParamFromCache('publishedDateTo');
});

foreach(filterLinks, activateFilterToggle);
foreach(filterTextfields, activateFilterTextfield);

// Set the date field values manually from the browser history
let params = historyManager.getUrlParams();
$('#publishedDateFrom').val(params.publishedDateFrom || null);
$('#publishedDateTo').val(params.publishedDateTo || null);

historyManager.history.listen((location, action) => {
    let params = historyManager.getUrlParams();
    let actualPage = Number(params.page) || 0;
    initSearch(params, actualPage);
});

// Clear genre group listener: removes genre group filter:
$('#clearGenreGroups').on('click', (e) => {
    let params = historyManager.getUrlParams();
    delete params.genreGroups;
    historyManager.pushParams(params);
});

// Clear all filters listener: removes all filters:
$('#reset,input[type=reset]').on('click', (e) => {
    $('#publishedDateFrom').val('');
    $('#publishedDateTo').val('');
    historyManager.pushParams({});
});

// more button
$('#moreBtn').on('click', (e) => {
    let params = historyManager.getUrlParams();
    params.page = (Number(params.page) || 0) + 1;
    historyManager.pushParams(params, false);
});

// search Publish Date btn
$('#searchPublishDate').on('click', (e) => {
    let params = historyManager.getUrlParams();
    let publishedFrom = String($('#publishedDateFrom').val());
    let publishedTo = String($('#publishedDateTo').val());
    delete params.publishedDateFrom;
    delete params.publishedDateTo;
    delete params.publishedSince;
    if (publishedFrom.length > 0) {
        params.publishedDateFrom = publishedFrom;
    }
    if (publishedTo.length > 0) {
        params.publishedDateTo = publishedTo;
    }

    historyManager.pushParams(params);
});

/** ---------------------- filter accept mobile - some special handling for non-standard fields: */
$('.filteracceptmobile,button.searchsubmit').on('click', (e) => {
    // Emulate key / click events on the original elements:
    let keyEvt = new Event('keypress');
    keyEvt.keyCode = 13;

    $('[data-filter=query]')[0].dispatchEvent(keyEvt);
    $('#searchPublishDate').trigger('click');
});
/** ------------------------------------------------------------------------------*/

// ------------ Initialize Date Picker: ----------------
// // @see components/fengyuanchen_datepicker.js for defaults / global settings
$('input.datepicker').datepicker();

// start first initial search
initSearch(params, Number(params.page) || 0, true);

/** ------------------------------ Initial Filter container open --------------------------*/
/** Containers that have active filter params set are set to open on page load */
(() => {
    let params = historyManager.getUrlParams();
    Object.keys(params).forEach((key) => {
        let selector = `[data-filter-container*=${key}]`;
        $(selector).addClass('open');
    });
})();
